import { STANDARD_TIMESTAMP_FORMAT } from 'constants/date';
import moment from 'moment-timezone';

export const formatDateTime = (timestamp, format, timezone, emptyValue) => {
    if (!timestamp || !moment(timestamp).isValid()) return emptyValue || '';
    const tz = timezone || moment.tz.guess();
    const dtFormat = format || STANDARD_TIMESTAMP_FORMAT;
    return moment.tz(timestamp, tz).format(dtFormat);
};

export const formatDurationHourMinute = (seconds = 0) => {
    const totalMinutes = Math.floor(seconds / 60);
    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;
    return hours > 0 ? `${hours}h ${minutes}m` : `${minutes}m`;
};